export interface PublishTierOverride {
    expires?: number;
    created?: number;
    publishTier?: string;
}

export const PublishTierOverrideFields = 'created expires publishTier';
